import axios from "axios";

const baseURL = "https://api-dev.ajuda.pet";
// const baseURL = "http://localhost:3002";

const api = axios.create({
  baseURL,
});

export default api;
